import { Grid } from "@sidelinesports/fan-design-system";
import { Page } from "../../analytics/Page.tsx";
import { FullscreenFixedLayout } from "../../components";
import { useConditionalGameRedirect } from "./hooks/use-conditional-game-redirect.ts";
import {
  useCurrentGameId,
  useCurrentGameQuery,
} from "./hooks/use-current-game.ts";
import { useRecordGameEntry } from "./hooks/use-record-game-entry.ts";
import styles from "./PlayGamePage.module.css";
import {
  MessageController,
  MostRecentFeaturedMessageToaster,
  PageHeader,
  PlayerCardsSection,
  RundownSection,
  SponsorSection,
  UnderCardSection,
} from "./sections";

export const PlayGamePage = () => {
  useConditionalGameRedirect();

  const gameId = useCurrentGameId();
  const { data: game } = useCurrentGameQuery();
  useRecordGameEntry(gameId, game?.status);

  return (
    <Page name="PlayGame">
      <FullscreenFixedLayout className={styles.layout} header={<PageHeader />}>
        <MessageController />
        <Grid className={styles.contentGrid} style={{ overflowX: "hidden" }}>
          <RundownSection />
          <PlayerCardsSection />
          <UnderCardSection />
          <SponsorSection />
        </Grid>
      </FullscreenFixedLayout>
      <MostRecentFeaturedMessageToaster />
    </Page>
  );
};
